// extracted by mini-css-extract-plugin
module.exports = {"flex":"styles_flex__1lf9M","title":"styles_title__1HJJE"};